module.exports = __webpack_public_path__ + "media/images/front-2984f07b2178517adee402023cef933f.jpg";